module.exports = __webpack_public_path__ + "static/pick-and-pack-db02935415c651746dac37a5eebb5c6d.png";